const serialize = function(data) {
    if (!data) return ''
    let pairs = []
    for (let name in data) {
        if (!data[name]) continue
        if (typeof data[name] === 'function') continue
        let value = data[name].toString()
        name = encodeURIComponent(name)
        value = encodeURIComponent(value)
        pairs.push(name + '=' + value)
    }
    return pairs.join('&')
}

class Request {
    request = function() {}

    constructor() {
        this.request = function(
            url, data, method = 'GET', responseType = 'json', header) {
            return new Promise((resolve, reject) => {
                let xhr = new XMLHttpRequest()
                let params = null
                xhr.onreadystatechange = function() {
                    if (this.readyState !== 4) {
                        return
                    }
                    if (this.status === 200) {
                        resolve(this.response)
                    } else {
                        reject(new Error(this.statusText))
                    }
                } // 请求状态变化时的回调处理函数
                if (method.toUpperCase() === 'GET') {
                    url = url + '?' + serialize(data)
                }
                else if (method.toUpperCase() === 'POST') {
                    // params = serialize(data)
                    params = JSON.stringify(data)
                }
                xhr.request_url = xhr.url || url
                xhr.open(method, url, true)
                for (let i in header) {
                    xhr.setRequestHeader(i, header[i])
                }
                if (method.toUpperCase() === 'POST') {
                    xhr.setRequestHeader('Content-Type',
                        'application/json')
                        // 'application/x-www-form-urlencoded; charset=UTF-8')
                } else {
                    !xhr['Content-Type'] &&
                    (xhr['Content-Type'] = 'application/json')
                }
                xhr.responseType = responseType
                xhr.send(params)
            })
        }
    }

    get(url, data) {
        return this.request(url, data, 'GET')
    }

    post(url, data) {
        return this.request(url, data, 'POST')
    }
}

export default new Request()
